import { Injectable, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class CanonicalService {

  constructor(@Inject(DOCUMENT) private doc) {}

  createLinkForCanonicalURL() {
    const canonicalTag = this.doc.head.querySelector('[rel=canonical]');
    if (canonicalTag) {
      canonicalTag.remove();
    }
     let link: HTMLLinkElement = this.doc.createElement('link');
     link.setAttribute('rel', 'canonical');
     this.doc.head.appendChild(link);
     link.setAttribute('href', this.doc.URL);
   }
}